<template>
  <section class="trustedNew">
    <div class="trustedNew__info">
      <div class="trustedNew__title">{{$t('qic_landing_trusted_title')}}</div>
      <div class="trustedNew__desc">{{$t('qic_landing_trusted_desc')}}</div>
    </div>
    <div class="trustedNew__wrapper-img">
      <img :src="image" alt="since" class="trustedNew__img">
    </div>
  </section>
</template>

<script>
export default {
  name: 'LandingTrusted',
  props: {
    image: { type: String }
  }
}
</script>
